import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},[_c('path',{attrs:{"d":"M15.77 17.62L9 10.85l-6.77 6.77a1.3 1.3 0 01-.92.38 1.3 1.3 0 01-.93-.38 1.3 1.3 0 010-1.85L7.15 9 .38 2.23a1.3 1.3 0 010-1.85 1.3 1.3 0 011.85 0L9 7.15 15.77.38a1.3 1.3 0 011.85 0 1.3 1.3 0 010 1.85L10.85 9l6.77 6.77a1.3 1.3 0 010 1.85 1.3 1.3 0 01-.92.38 1.3 1.3 0 01-.93-.38z","fill":"#990ae3"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
